import { Injectable } from "@angular/core";
import { Route } from "@obg/ngx.router";
import { intersection, isEmpty } from "lodash-es";

import { TrackingConfigService } from "../tracking.config";

import { TrackingData } from "./tracking-area.model";

@Injectable({
	providedIn: "root",
})
export class TrackingAreaService {
	private trackingData: Record<string, TrackingData> = {};

	constructor(private trackingConfigService: TrackingConfigService) {}

	getTrackingData(route: Route): TrackingData | undefined {
		const trackingData = this.trackingData[route.name];
		return this.processTrackingData(trackingData, route);
	}

	registerTrackingData(trackingData: Record<string, TrackingData>) {
		this.trackingData = { ...this.trackingData, ...trackingData };
	}

	private processTrackingData(trackingData: TrackingData | undefined, route: Route): TrackingData | undefined {
		if (!isEmpty(route.params) && trackingData && !trackingData.maskedParams) {
			trackingData.maskedParams = this.maskParams(route.params!);
		}

		if (!isEmpty(route.queryParams) && trackingData && !trackingData.maskedQueryParams) {
			trackingData.maskedQueryParams = this.maskParams(route.queryParams!);
		}

		return trackingData;
	}

	private maskParams(params: Record<string, any>) {
		const defaultMaskedParams = this.trackingConfigService.getMaskedParams();

		const trackedParams = intersection(Object.keys(params), Object.keys(defaultMaskedParams)).reduce(
			(maskedParams: Record<string, string>, item: string) => {
				maskedParams[item] = defaultMaskedParams[item];
				return maskedParams;
			},
			{}
		);

		return !isEmpty(trackedParams) ? trackedParams : undefined;
	}
}
